import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Context from "../context/Context";
import { useLocation, useNavigate, useParams } from "react-router";
import { useUserAuth } from "../context/UserAuthContext";
import backButton from "../assests/backButton.svg";
import { isEmpty } from "lodash";
import LoadingFromCenter from "../Components/LoadingFromCenter/LoadingFromCenter";
import user from "../assests/user.svg";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";
import { createSearchParams } from "react-router-dom";

export default function LikedUsers() {
  const [likedUserList, setLikedUserList] = useState([]);
  const { userIdToken, details, loadHomePageDetails } = useContext(Context);
  const [pageNumber, setPageNumber] = useState(1);
  const [dataloading, setDataLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const { currentUser, searchParams } = useUserAuth();
  const [likeCount, setLikeCount] = useState();
  const { organizerName, campaignUniqueText, contestUniqueText, videoId } =
    useParams();
  const location = useLocation();
  const navigate = useNavigate();
  var contestDetails =
    details &&
    details.contests &&
    details.contests.filter((el) => {
      return el.contestUniqueText === contestUniqueText;
    });
  let orgId = contestDetails && contestDetails[0]?.orgId;
  let cmpId = contestDetails && contestDetails[0]?.campaignId;
  let cntstid = contestDetails && contestDetails[0]?.contestId;

  const token = userIdToken || currentUser?.accessToken;
  useEffect(() => {
    if (isEmpty(details)) {
      loadHomePageDetails(organizerName, campaignUniqueText);
    }
  }, []);
  useEffect(() => {
    if (!isEmpty(details)) {
      setDataLoading(true);
      let cancel;
      let url = `${process.env.REACT_APP_LIKED_USER}/${orgId}/${cmpId}/${cntstid}/${videoId}?page=${pageNumber}&limit=10`;
      axios({
        method: "get",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      })
        .then((res) => {
          setLikeCount(res?.data?.data?.likesCount);
          setLikedUserList((prevContestData) => {
            const newData = Array.isArray(res?.data?.data?.videoLikes)
              ? res.data.data.videoLikes
              : [];
            return [...new Set([...prevContestData, ...newData])];
          });
          setHasMore(res?.data?.data?.videoLikes?.length > 0);
          setDataLoading(false);
        })
        .catch((e) => {
          if (axios.isCancel(e)) return;
          setDataLoading(false);
        });

      return () => cancel();
    }
  }, [details, pageNumber]);
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (dataloading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataloading, hasMore]
  );

  const handleNavigateToPrevLocation = () => {
    navigate({
      pathname: location?.state.previousLocation,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };

  const getProfilePicture = (uid) => {
    let url = `https://storage.googleapis.com/goviralprofiledatas/${uid}`;
    return url;
  };
  return (
    <div className="widthController pb-[50px]">
      <FloatingWidgets page="like" endTime={details?.endDate} />

      <div className="flex gap-[10px] items-center py-[12px] px-[20px] sticky top-0 header-bg">
        <div
          className="w-[40px] h-[40px] rounded-full flex items-center justify-center cursor-pointer"
          onClick={handleNavigateToPrevLocation}
        >
          <img src={backButton} />
        </div>
        <p className="text-large">
          Votes you got {likeCount && `(${likeCount})`}
        </p>
      </div>
      <div className="px-[20px]">
        {likedUserList &&
          likedUserList?.map((obj, index) => {
            return (
              <>
                <div
                  key={index}
                  ref={
                    index === likedUserList.length - 1 ? lastElementRef : null
                  }
                  className="flex items-center gap-[10px] py-[10px]"
                >
                  <img
                    src={getProfilePicture(obj?.uid) || user}
                    alt=""
                    className="h-[40px] w-[40px] rounded-full overflow-hidden  object-cover"
                    onError={(e) => {
                      e.target.src = user;
                    }}
                  />
                  <p>{obj?.userName || obj?.phone}</p>
                </div>
                <div className="seperator" />
              </>
            );
          })}
      </div>
      {dataloading && (
        <div className="w-[100%] flex justify-center">
          <div className="w-[20px]">
            <LoadingFromCenter />
          </div>
        </div>
      )}
    </div>
  );
}
